import { render } from "./WasteManagement.vue?vue&type=template&id=fede75d6&scoped=true"
import script from "./WasteManagement.vue?vue&type=script&lang=js"
export * from "./WasteManagement.vue?vue&type=script&lang=js"

import "./WasteManagement.vue?vue&type=style&index=0&id=fede75d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fede75d6"]])

export default __exports__